import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  role: "img",
  viewBox: "0 0 92 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.63 12.26a1 1 0 0 0-.93 0l-2.84 1.5A1 1 0 0 1 3.4 12.7l.54-3.17a1 1 0 0 0-.29-.88L1.36 6.4a1 1 0 0 1 .56-1.7l3.17-.47a1 1 0 0 0 .76-.55L7.27.82a1 1 0 0 1 1.79 0l1.42 2.87c.15.3.43.5.75.55l3.18.46a1 1 0 0 1 .55 1.7l-2.3 2.25a1 1 0 0 0-.28.88l.54 3.17a1 1 0 0 1-1.45 1.05l-2.84-1.5ZM28.59 12.26a1 1 0 0 0-.94 0l-2.84 1.5a1 1 0 0 1-1.45-1.06l.55-3.17a1 1 0 0 0-.3-.88l-2.3-2.24a1 1 0 0 1 .56-1.7l3.18-.47a1 1 0 0 0 .75-.55L27.22.82a1 1 0 0 1 1.8 0l1.42 2.87c.14.3.42.5.75.55l3.18.46a1 1 0 0 1 .55 1.7l-2.3 2.25a1 1 0 0 0-.29.88l.55 3.17a1 1 0 0 1-1.45 1.05l-2.84-1.5ZM46.8 12.26a1 1 0 0 0-.93 0l-2.84 1.5a1 1 0 0 1-1.45-1.06l.54-3.17a1 1 0 0 0-.28-.88l-2.3-2.24a1 1 0 0 1 .55-1.7l3.18-.47a1 1 0 0 0 .75-.55L45.44.82a1 1 0 0 1 1.8 0l1.42 2.87c.14.3.42.5.75.55l3.17.46a1 1 0 0 1 .56 1.7l-2.3 2.25a1 1 0 0 0-.29.88l.55 3.17a1 1 0 0 1-1.46 1.05l-2.84-1.5ZM65.9 12.26a1 1 0 0 0-.94 0l-2.84 1.5a1 1 0 0 1-1.45-1.06l.54-3.17a1 1 0 0 0-.29-.88l-2.3-2.24a1 1 0 0 1 .56-1.7l3.18-.47a1 1 0 0 0 .75-.55L64.53.82a1 1 0 0 1 1.8 0l1.41 2.87c.15.3.43.5.76.55l3.17.46a1 1 0 0 1 .56 1.7l-2.3 2.25a1 1 0 0 0-.29.88l.54 3.17a1 1 0 0 1-1.45 1.05l-2.84-1.5Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M84.51 12.14V.26c.36 0 .71.19.9.56l1.42 2.88c.14.29.43.5.75.54l3.18.46a1 1 0 0 1 .55 1.7l-2.3 2.25a1 1 0 0 0-.28.88l.54 3.17a1 1 0 0 1-1.45 1.05l-2.84-1.5a1 1 0 0 0-.47-.1Z",
      opacity: "0.3"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M84.51.26v11.88a1 1 0 0 0-.46.12l-2.84 1.5a1 1 0 0 1-1.46-1.06l.55-3.17a1 1 0 0 0-.3-.88l-2.29-2.24a1 1 0 0 1 .56-1.7l3.17-.47a1 1 0 0 0 .75-.54L83.61.82a.99.99 0 0 1 .9-.56Z"
    }, null, -1)
  ])))
}
export default { render: render }